import { Box, Typography } from '@mui/material';
import { useTranslation, Trans } from 'react-i18next';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

type SubtitleProps = {
  descriptionI18Key: string;
};

const Subtitle = ({ descriptionI18Key }: SubtitleProps) => {
  const { t } = useTranslation(['flexflow']);

  return (
    <Grid2 container sx={{ justifyContent: 'center', flexDirection: 'column' }}>
      <Typography variant="subtitle1" sx={{ display: 'flex', alignItems: 'center', 'flex-wrap': 'wrap', gap: '4px' }}>
        <Box>
          <Trans i18nKey={descriptionI18Key} ns="flexflow" components={[<strong />]} />
        </Box>
      </Typography>
      <Typography variant="subtitle1">
        {t('you can change the status of an employee in the view edit employees section', { ns: 'flexflow' })}
      </Typography>
    </Grid2>
  );
};

export default Subtitle;
